/*
 * @Author: your name
 * @Date: 2021-11-24 22:42:02
 * @LastEditTime: 2021-11-26 14:21:08
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /static-pc/src/utils/environment.js
 */
import BASE_CONFIG from 'BASE_CONFIG'
/**
 * 返回当前的运行环境 开发dev、日常daily、预发pre、线上publish
 */
export function env() {
	return BASE_CONFIG.name
}

/**
 * 返回当前的构建环境 development production
 */
export function buildEnv() {
	return BASE_CONFIG.name
}

/**
 * 是否在ios环境
 */
export function isIosBrowser() {
	let u = window.navigator.userAgent.toLowerCase();
	return /iphone|ipad|ipod/i.test(u)
}

/**
 * 是否在android环境
 */
export function isAndroidBrowser() {
	let u = window.navigator.userAgent.toLowerCase();
	return (/android/i.test(u))
}